import { FetchError } from 'ofetch';

import { StatusCode } from '~~core';

import type { RouteLocationNormalized } from '#vue-router';

export const goneRouteName = 'signatureRequestKind-signatureRequestKey-gone';

export function useContextedGoneError() {
  const localePath = useLocalePath();

  const isGoneRoute = (route: RouteLocationNormalized) => {
    const goneRouteRegex = new RegExp(goneRouteName);

    return goneRouteRegex.test(route.name);
  };

  const shouldGoneError = (route: RouteLocationNormalized) => {
    const error = useError() as Ref<FetchError>;

    if (!route || !('signatureRequestKey' in route.params)) return false;

    return error.value?.statusCode === StatusCode.GONE;
  };

  const navigateToGone = (route: RouteLocationNormalized) => {
    const path = localePath({
      name: goneRouteName,
      params: route?.params,
      query: route?.query,
    });

    const error = useError();

    if (!error.value) return navigateTo(path);

    return clearError({ redirect: path });
  };

  return {
    isGoneRoute,
    shouldGoneError,
    navigateToGone,
  };
}
